import React, { useEffect, useState } from "react";
import exportImage from "../../../asset/Images";
import { Controller, useFieldArray, useForm, useWatch } from "react-hook-form";
import InputField from "../../InputField";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import { categoryData } from "../../../globalApi/GlobalApi";
import axios from "axios";
import Popup from "../../popupmodal/Popup";

export default function ProformaInvoice() {
  const storedBranchArray =
    JSON.parse(sessionStorage.getItem("branchNames")) || [];
  const [selectBranch, setSelectedBranch] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [proformaData, setProformaData] = useState(null);
  const [selectCategory, setSelectedCategory] = useState(null);
  const [selectedValue, setSelectedValue] = useState("");
  const [popupType, setPopupType] = useState({
    type: "",
    data: "",
  });

  let companyName = sessionStorage.getItem("companyName");
  const [selectedBankValue, setSelectedBankValue] = useState("");

  const today = new Date().toISOString().split("T")[0];
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const {
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      formValue: [
        {
          serialNo: "",
          description: "",
          hsnCd: "",
          percentage: "",
          qty: "",
          price: "",
          amount: "",
        },
      ],
      date: today,
      siteVisitDate: today,
      branchSelect: "",
    },
  });
  const { fields, append, remove, replace } = useFieldArray({
    name: "formValue",
    control,
  });
  const { formValue, paymentSplitting, descriptionCount } = watch();

  const navigate = useNavigate();
  const { state } = useLocation();

  console.log("state", state);

  // GET API START
  const quotationData = async () => {
    return await axios.get(
      `${process.env.REACT_APP_HOST}/quotation/${selectBranch}/all`
    );
  };

  const { data, isLoading, isError, refetch } = useQuery(
    ["quotationData", selectBranch],
    quotationData,
    {
      enabled: !!selectBranch,
      refetchOnWindowFocus: false,
    }
  );
  // GET API END

  let details = (data && data?.data) || [];

  let customerDetails = null;
  if (selectedValue?.trim()) {
    const [namePart, mobilePart] = selectedValue
      .split(":")
      .map((s) => s.trim());

    customerDetails =
      details &&
      details.find(
        (data) =>
          data?.customerName?.toLowerCase() === namePart?.toLowerCase() &&
          data?.mobileNumber === mobilePart
      );
  }

  // POST API START
  const { mutate, isLoading: postLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_HOST}/performainvoice/${selectBranch}`,
          postData
        );
        return response.data;
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error; // Rethrow to trigger onError
      }
    },
    {
      onSuccess: () => {
        refetch();
        setIsModalOpen(true);
        setPopupType({
          ...popupType,
          type: "add performa",
        });
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to add Proforma. Please try again.");
      },
    }
  );

  // UPDATE API
  const { mutate: updateApi, isLoading: putLoading } = useMutation(
    (postData) =>
      axios.put(
        `${process.env.REACT_APP_HOST}/performainvoice/${selectBranch}/${state?.id}`,
        postData
      ),
    {
      onSuccess: () => {
        refetch();
        setIsModalOpen(true);
        setPopupType({
          ...popupType,
          type: "add performa",
        });
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
      },
    }
  );

  // GET API START FOR BANK DETAILS
  const bankData = async (companyName) => {
    const response = await axios.get(
      `${process.env.REACT_APP_HOST}/register/byCompanyName`,
      { params: { companyName } } // Sending branchName as a parameter
    );
    return response.data; // Returning the data from the response
  };

  const { data: bankDetails, isLoading: bankLoading } = useQuery(
    ["bankData", companyName],
    () => bankData(companyName),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(companyName),
    }
  );

  // GET API END

  // GET API START FOR BRANCH DETAILS
  const branchData = async (branchName) => {
    const response = await axios.get(
      `${process.env.REACT_APP_HOST}/branches/bybranchname`,
      { params: { branchName } } // Sending branchName as a parameter
    );
    return response.data; // Returning the data from the response
  };

  const { data: branchDetails, isLoading: branchLoading } = useQuery(
    ["branchData", selectBranch],
    () => branchData(selectBranch),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(selectBranch),
    }
  );
  // GET API END

  // SETVALUE

  useEffect(() => {
    if (state?.id) {
      setValue("performaInvoiceNo", state?.performaInvoiceNo || null);
      setValue("date", state?.date || null);
      setValue("projectNo", state?.projectNo || null);
      setValue("customerName", state?.customerName || null);
      setValue("mobileNo", state?.mobileNo || null);
      setValue("doorNo", state?.doorNo || null);
      setValue("street", state?.street || null);
      setValue("locality", state?.locality || null);
      setValue("city", state?.city || null);
      setValue("state", state?.state || null);
      setValue("pincode", state?.pincode || null);
      setValue("customerGstNo", state?.customerGstNo || null);
      setValue("branchDetailsName", state?.branchDetailsName || null);
      setValue("branchDetailsNo", state?.branchDetailsNo || null);
      setValue("branchDetailsStreet", state?.branchDetailsStreet || null);
      setValue("branchDetailsLocality", state?.branchDetailsLocality || null);
      setValue("branchDetailsCity", state?.branchDetailsCity || null);
      setValue("branchDetailsPincode", state?.branchDetailsPincode || null);
      setValue("branchDetailsPhoneNo", state?.branchDetailsPhoneNo || null);
      setValue(
        "branchDetailsAltPhoneNo",
        state?.branchDetailsAltPhoneNo || null
      );
      setValue("gstIn", state?.gstIn || null);
      setValue("currentAccHoldersName", state?.currentAccHoldersName || null);
      setValue("bankName", state?.bankName || null);
      setValue("accNo", state?.accNo || null);
      setValue("ifscCode", state?.ifscCode || null);
      setValue("branch", state?.branch || null);
      setValue("phoneNo", state?.phoneNo || null);
      setValue("kindAttn", state?.kindAttn || null);
      setValue("natureOfBusiness", state?.natureOfBusiness || null);
      setValue("siteAddress", state?.siteAddress || null);
      setValue("siteVisitDate", state?.siteVisitDate || null);
      setValue("discount", state?.discount || null);
      setValue("totalAmount", state?.totalAmount || null);
      setValue("gstPercentage", state?.gstPercentage || null);
      setValue("customerGst", state?.customerGst || null);
      setValue("categoryType", state?.categoryType || null);
      setValue("otherCategoryType", state?.otherCategoryType || null);
      setValue("poNo", state?.poNo || null);
      setValue("cusOrderDate", state?.cusOrderDate || null);
      setValue("reference", state?.reference || null);
      setValue("roundOff", state?.roundOff || null);
      setValue("branchSelect", state?.branchSelect || null);
      setSelectedBranch(state?.branchSelect);
      // setValue("appendList", state?.appendList || []);
      if (state?.appendList?.length > 0) {
        replace(
          state?.appendList?.map((item) => ({
            serialNo: item?.serialNo || null,
            description: item?.description || null,
            qty: item?.qty || null,
            hsnCd: item?.hsnCd || null,
            percentage: item?.percentage || null,
            amount: item?.amount || null,
            total: item?.total || null,
            price: item?.price || null,
          }))
        );
      }
    }
  }, [state, setValue, replace]);

  // Selected Customer Details setValue

  useEffect(() => {
    console.log("customer", customerDetails);
    if (customerDetails && selectedValue) {
      setValue("branchSelect", customerDetails?.branchSelect || "");
      setSelectedBranch(customerDetails?.branchSelect);
      setValue("customerName", customerDetails?.customerName || "");
      setValue("kindAttn", customerDetails?.kindAttn || "");
      setValue("mobileNo", customerDetails?.mobileNumber || "");
      setValue("doorNo", customerDetails?.doorNo || "");
      setValue("street", customerDetails?.street || "");
      setValue("locality", customerDetails?.locality || "");
      setValue("city", customerDetails?.city || "");
      setValue("state", customerDetails?.state || "");
      setValue("pincode", customerDetails?.pincode || "");
      setValue("natureOfBusiness", customerDetails?.natureOfBusiness || "");
      setValue("siteAddress", customerDetails?.siteAddress || "");
      setValue("siteVisitDate", customerDetails?.siteVisitDate || "");
      setValue("discount", customerDetails?.discount || "");
      setValue("totalAmount", customerDetails?.totalInvoiceAmount || "");

      setValue("categoryType", customerDetails?.categoryType || null);
      setValue("otherCategoryType", customerDetails?.otherCategoryType || null);
      setValue("customerGst", customerDetails?.customerGstIn || null);
      setValue("roundOff", customerDetails?.roundOff || null);

      if (customerDetails?.forms?.length > 0) {
        replace(
          customerDetails?.forms?.map((item) => ({
            description: item?.description || null,
            qty: item?.qty || null,
            price: item?.price || null,
            serialNo: "",
            hsnCd: "",
            percentage: "",
            amount: "",
          }))
        );
      }
    }
  }, [setValue, selectedValue, replace]);

  // BANK DETAILS

  useEffect(() => {
    if (bankDetails?.length && selectedBankValue) {
      const match = bankDetails?.find(
        (data) =>
          `${data.currentAccHolderName} : ${data?.accNo}` === selectedBankValue
      );

      if (match) {
        setValue("currentAccHolderName", match?.currentAccHolderName || null);
        setValue("bankName", match?.bankName || null);
        setValue("accNo", match?.accNo || null);
        setValue("ifscCode", match?.ifscCode || null);
        setValue("branch", match?.branch || null);
        setValue("phoneNo", match?.phoneNo || null);
      } else {
        // No match found, reset the fields
        setValue("currentAccHolderName", null);
        setValue("bankName", null);
        setValue("accNo", null);
        setValue("ifscCode", null);
        setValue("branch", null);
        setValue("phoneNo", null);
      }
    } else {
      // Optional: reset if selectedBankValue is empty or no bankDetails
      setValue("currentAccHolderName", null);
      setValue("bankName", null);
      setValue("accNo", null);
      setValue("ifscCode", null);
      setValue("branch", null);
      setValue("phoneNo", null);
    }
  }, [bankDetails, selectedBankValue, setValue]);

  // Branch Details setValue
  useEffect(() => {
    if (branchDetails && branchDetails != null) {
      setValue("branchDetailsName", branchDetails?.branchName || "");
      setValue("branchDetailsNo", branchDetails?.no || "");
      setValue(
        "branchDetailsStreet",
        branchDetails?.street || state?.street || ""
      );
      setValue("branchDetailsLocality", branchDetails?.locality || "");
      setValue("branchDetailsCity", branchDetails?.city || "");
      setValue("branchDetailsPincode", branchDetails?.pincode || "");
      setValue("branchDetailsPhoneNo", branchDetails?.phoneNo || "");
      setValue("branchDetailsAltPhoneNo", branchDetails?.altPhoneNo || "");
      setValue("gstIn", branchDetails?.gstIn || "");
    }
  }, [setValue, branchDetails]);

  // DUPLICATE ENTRY
  useEffect(() => {
    const duplicateData = JSON.parse(localStorage.getItem("duplicateData"));
    console.log("duplicate", duplicateData);
    if (duplicateData) {
      setValue("date", duplicateData?.date || "");
      setValue("projectNo", duplicateData?.projectNo || "");
      setValue("customerName", duplicateData?.customerName || "");
      setValue("mobileNo", duplicateData?.mobileNo || "");
      setValue("doorNo", duplicateData?.doorNo || "");
      setValue("street", duplicateData?.street || "");
      setValue("locality", duplicateData?.locality || "");
      setValue("city", duplicateData?.city || "");
      setValue("state", duplicateData?.state || "");
      setValue("pincode", duplicateData?.pincode || "");
      setValue("customerGst", duplicateData?.customerGst || "");
      setValue("branchDetailsName", duplicateData?.branchDetailsName || "");
      setValue("branchDetailsNo", duplicateData?.branchfDetailsNo || "");
      setValue("branchDetailsStreet", duplicateData?.branchDetailsStreet || "");
      setValue(
        "branchDetailsLocality",
        duplicateData?.branchDetailsLocality || ""
      );
      setValue("branchDetailsCity", duplicateData?.branchDetailsCity || "");
      setValue(
        "branchDetailsPincode",
        duplicateData?.branchDetailsPincode || ""
      );
      setValue(
        "branchDetailsPhoneNo",
        duplicateData?.branchDetailsPhoneNo || ""
      );
      setValue(
        "branchDetailsAltPhoneNo",
        duplicateData?.branchDetailsAltPhoneNo || ""
      );
      setValue("gstIn", duplicateData?.gstIn || "");
      setValue(
        "currentAccHoldersName",
        duplicateData?.currentAccHoldersName || ""
      );
      setValue("bankName", duplicateData?.bankName || "");
      setValue("accNo", duplicateData?.accNo || "");
      setValue("ifscCode", duplicateData?.ifscCode || "");
      setValue("branch", duplicateData?.branch || "");
      setValue("phoneNo", duplicateData?.phoneNo || "");
      setValue("natureOfBusiness", duplicateData?.natureOfBusiness || "");
      setValue("siteAddress", duplicateData?.siteAddress || "");
      setValue("siteVisitDate", duplicateData?.siteVisitDate || "");
      setValue("discount", duplicateData?.discount || "");
      setValue("totalAmount", duplicateData?.totalAmount || "");
      setValue("gstPercentage", duplicateData?.gstPercentage || "");
      setValue("branchSelect", duplicateData?.branchSelect || "");
      setSelectedBranch(duplicateData?.branchSelect);
      setValue("status", duplicateData?.status || "");
      setValue("kindAttn", duplicateData?.kindAttn || "");
      setValue("customerGst", duplicateData?.customerGst || null);
      setValue("categoryType", duplicateData?.categoryType || null);
      setValue("otherCategoryType", duplicateData?.otherCategoryType || null);
      setValue("poNo", duplicateData?.poNo || null);
      setValue("cusOrderDate", duplicateData?.cusOrderDate || null);
      setValue("reference", duplicateData?.reference || null);
      setValue("roundOff", duplicateData?.roundOff || null);

      // Handle appendList
      if (duplicateData?.appendList && duplicateData?.appendList?.length > 0) {
        replace(
          duplicateData?.appendList.map((item) => ({
            serialNo: item?.serialNo || "",
            description: item?.description || "",
            qty: item?.qty || "",
            hsnCd: item?.hsnCd || "",
            percentage: item?.percentage || "",
            price: item?.price || "",
            amount: item?.amount || "",
          }))
        );
      }
    }
  }, [setValue, replace]);

  useEffect(() => {
    return () => {
      localStorage.removeItem("duplicateData");
    };
  }, []);

  // Sum of all amounts
  const sumOfAmounts = formValue?.reduce((sum, item) => {
    const qty = Number(item?.qty || 0);
    const price = Number(item?.price || 0);
    return sum + qty * price;
  }, 0);

  // Discount
  const discount = Number(watch("discount") || 0);

  // GST Percentage
  const gstPercentage = Number(watch("gstPercentage") || 0);

  // Amount after discount
  const amountAfterDiscount = sumOfAmounts - discount;

  // GST amount
  const gstAmount = (amountAfterDiscount * gstPercentage) / 100;

  // Final Total
  const finalTotalAmount = amountAfterDiscount + gstAmount;
  useEffect(() => {
    setValue("totalAmount", finalTotalAmount.toFixed(2));
  }, [finalTotalAmount, setValue]);

  // FORM SUBMISSION
  const onSubmit = (data) => {
    const formData = {
      branchSelect: data?.branchSelect || null,
      performaInvoiceNo: data?.performaInvoiceNo || null,
      date: data?.date || null,
      projectNo: data?.projectNo || null,
      customerName: data?.customerName || null,
      kindAttn: data?.kindAttn || null,
      mobileNo: data?.mobileNo || null,
      doorNo: data?.doorNo || null,
      street: data?.street || null,
      locality: data?.locality || null,
      city: data?.city || null,
      state: data?.state || null,
      pincode: data?.pincode || null,
      natureOfBusiness: data?.natureOfBusiness || null,
      siteAddress: data?.siteAddress || null,
      siteVisitDate: data?.siteVisitDate || null,
      discount: data?.discount || null,
      gstPercentage: data?.gstPercentage || null,
      totalAmount: data?.totalAmount || null,
      customerGst: data?.customerGst || null,
      branchDetailsName: data?.branchDetailsName || null,
      branchDetailsNo: data?.branchDetailsNo || null,
      branchDetailsStreet: data?.branchDetailsStreet || null,
      branchDetailsLocality: data?.branchDetailsLocality || null,
      branchDetailsCity: data?.branchDetailsCity || null,
      branchDetailsPincode: data?.branchDetailsPincode || null,
      branchDetailsPhoneNo: data?.branchDetailsPhoneNo || null,
      branchDetailsAltPhoneNo: data?.branchDetailsAltPhoneNo || null,
      gstIn: data?.gstIn || null,
      currentAccHoldersName: data?.currentAccHolderName || null,
      bankName: data?.bankName || null,
      accNo: data?.accNo || null,
      ifscCode: data?.ifscCode || null,
      branch: data?.branch || null,
      phoneNo: data?.phoneNo || null,
      appendList: formValue || [],
      customerGst: data?.customerGst || null,
      categoryType: data?.categoryType || null,
      otherCategoryType: data?.otherCategoryType || null,
      poNo: data?.poNo || null,
      cusOrderDate: data?.cusOrderDate || null,
      reference: data?.reference || null,
      roundOff: data?.roundOff || null,
    };
    setProformaData(formData);
    if (state?.id) {
      updateApi(formData);
    } else {
      mutate(formData);
    }
  };

  return (
    <>
      <div className="screen_mainContainer">
        <div className="screen_InnerContainer">
          <header className="screen_headerContainer">
            <div className="header_title">
              {state?.id ? (
                <>Edit Proforma Invoice</>
              ) : (
                <>Add Proforma Invoice</>
              )}
            </div>
            <div
              style={{
                width: "35%",
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <div className="header_proforma">
                <input
                  list="customers"
                  placeholder="Select customer"
                  className="branchSelect"
                  value={selectedValue}
                  onChange={(e) => {
                    setSelectedValue(e.target.value);
                  }}
                />
                <datalist id="customers">
                  {details?.map((item, index) => (
                    <option
                      key={index}
                      value={`${item.customerName} : ${item.mobileNumber}`}
                    />
                  ))}
                </datalist>
              </div>
              <div className="header_proforma">
                <Controller
                  name="branchSelect"
                  control={control}
                  rules={{ required: "Branch selection is required" }}
                  render={({ field }) => (
                    <select
                      {...field}
                      className="branchSelect"
                      onChange={(e) => {
                        field.onChange(e); // Update form state
                        setSelectedBranch(e.target.value); // Update local state
                      }}
                      value={field.value || ""}
                    >
                      <option value="">-Select Branch-</option>
                      {storedBranchArray?.map((branch, index) => (
                        <option key={index} value={branch}>
                          {branch}
                        </option>
                      ))}
                    </select>
                  )}
                />
                {errors.branchSelect && (
                  <p style={{ color: "red" }}>{errors.branchSelect.message}</p>
                )}
              </div>
            </div>
          </header>
          <section className="py-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form_OverAllContainer">
                <div className="commonForm_container">
                  <div className="input_container">
                    <label className="inputLabel">Proforma Invoice No</label>
                    <Controller
                      control={control}
                      name="performaInvoiceNo"
                      rules={{ required: "Performa Invoice No is required" }}
                      render={({ field, fieldState: { error } }) => (
                        <>
                          <input
                            {...field}
                            type="text"
                            className="commonInputCss"
                          />
                          {error && (
                            <span
                              className="errorText"
                              style={{ color: "red" }}
                            >
                              {error.message}
                            </span>
                          )}
                        </>
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Date</label>
                    <Controller
                      control={control}
                      name="date"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="date"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Project No</label>
                    <Controller
                      control={control}
                      name="projectNo"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Customer Name</label>
                    <Controller
                      control={control}
                      name="customerName"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Kind Attn</label>
                    <Controller
                      control={control}
                      name="kindAttn"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Mobile Number</label>
                    {/* <Controller
                      control={control}
                      name="mobileNo"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="tel"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    /> */}
                    <Controller
                      control={control}
                      name="mobileNo"
                      rules={{
                        required: "Mobile number is required",
                        pattern: {
                          value: /^[6-9]\d{9}$/,
                          message: "Enter a valid 10-digit mobile number",
                        },
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <>
                          <input
                            {...field}
                            type="tel"
                            className="commonInputCss"
                          />
                          {error && (
                            <span
                              className="errorText"
                              style={{ color: "red" }}
                            >
                              {error.message}
                            </span>
                          )}
                        </>
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel"> Gst In</label>
                    <Controller
                      control={control}
                      name="customerGst"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Door No</label>
                    <Controller
                      control={control}
                      name="doorNo"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Street</label>
                    <Controller
                      control={control}
                      name="street"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Locality</label>
                    <Controller
                      control={control}
                      name="locality"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">City</label>
                    <Controller
                      control={control}
                      name="city"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">State</label>
                    <Controller
                      control={control}
                      name="state"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Pincode</label>
                    <Controller
                      control={control}
                      name="pincode"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Nature of Business</label>
                    <Controller
                      control={control}
                      name="natureOfBusiness"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>

                  <div className="input_container">
                    <label className="inputLabel">Site Address</label>
                    <Controller
                      control={control}
                      name="siteAddress"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>

                  <div className="input_container">
                    <label className="inputLabel">Site Visit Date</label>
                    <Controller
                      control={control}
                      name="siteVisitDate"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="date"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>

                  <div className="input_container">
                    <label className="inputLabel">Category</label>
                    <Controller
                      control={control}
                      name="categoryType"
                      render={({ field }) => (
                        <select {...field} className="commonInputCss">
                          <option value="">Select Category Type</option>
                          <option value="Residential">Residential</option>
                          <option value="Commercial">Commercial</option>
                          <option value="Others">Others</option>
                        </select>
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Other Category</label>
                    <Controller
                      control={control}
                      name="otherCategoryType"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Po.No</label>
                    <Controller
                      control={control}
                      name="poNo"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Cust Order Date</label>
                    <Controller
                      control={control}
                      name="cusOrderDate"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="date"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Reference</label>
                    <Controller
                      control={control}
                      name="reference"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                </div>

                {fields?.map((item, index) => {
                  const qty = Number(formValue?.[index]?.qty || 0);
                  const price = Number(formValue?.[index]?.price || 0);
                  const total = qty * price;
                  return (
                    <div key={item.id} className="appendForm_container">
                      <div className="sNoInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">S.No</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.serialNo`}
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              value={index + 1}
                              className="commonInputCss"
                            />
                          )}
                        />
                      </div>
                      <div className="descriptionInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">
                            Name of the Product/ Services
                          </label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.description`}
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              className="commonInputCss"
                            />
                          )}
                        />
                      </div>
                      <div className="qtyInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">Qty</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.qty`}
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              className="commonInputCss"
                            />
                          )}
                        />
                      </div>
                      <div className="qtyInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">HSN CD</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.hsnCd`}
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              className="commonInputCss"
                            />
                          )}
                        />
                      </div>
                      <div className="sNoInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">Unit</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.percentage`}
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              className="commonInputCss"
                            />
                          )}
                        />
                      </div>
                      <div className="qtyInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">Price</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.price`}
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              className="commonInputCss"
                            />
                          )}
                        />
                      </div>
                      <div className="qtyInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">Total</label>
                        )}

                        <Controller
                          control={control}
                          name={`formValue.${index}.amount`}
                          render={({ field }) => (
                            <input
                              {...field}
                              value={total} // override value with computed total
                              readOnly
                              className="commonInputCss"
                            />
                          )}
                        />
                      </div>
                      <div className="appendBtnContainer">
                        <div
                          className="appendBtn"
                          onClick={() => {
                            append();
                          }}
                        >
                          <img
                            className="mb-1"
                            src={exportImage?.addIcon}
                            alt="addIcon"
                          />
                        </div>
                        {index !== 0 && (
                          <div
                            className="appendBtn"
                            onClick={() => {
                              remove(index);
                            }}
                          >
                            <img
                              className="mb-1"
                              src={exportImage?.deleteIcon}
                              alt="deleteIcon"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}

                <div className="SpecificationsForm_container">
                  <div className="commonForm_container">
                    <div className="input_container">
                      <label className="inputLabel">Discount</label>
                      <Controller
                        control={control}
                        name="discount"
                        render={({ field }) => (
                          <input
                            {...field}
                            type="number"
                            step="any"
                            className="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Total GST %</label>
                      <Controller
                        control={control}
                        name="gstPercentage"
                        render={({ field }) => (
                          <input
                            {...field}
                            type="number"
                            step="any"
                            className="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Total Amount</label>
                      <Controller
                        control={control}
                        name="totalAmount"
                        render={({ field }) => (
                          <input
                            {...field}
                            type="number"
                            value={finalTotalAmount.toFixed(2)} // show 2 decimal places
                            readOnly
                            className="commonInputCss"
                            step="any"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Round Off</label>
                      <Controller
                        control={control}
                        name="roundOff"
                        render={({ field }) => (
                          <input
                            {...field}
                            type="text"
                            className="commonInputCss"
                            placeholder="Round Off"
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>

                <div className="billDetails_container">
                  <header className="header_title">Bill Details</header>
                  <div className="commonForm_container">
                    <div className="input_container">
                      <label className="inputLabel">Name</label>
                      <Controller
                        control={control}
                        name="branchDetailsName"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">No</label>
                      <Controller
                        control={control}
                        name="branchDetailsNo"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Street</label>
                      <Controller
                        control={control}
                        name="branchDetailsStreet"
                        render={({ field }) => (
                          <input
                            {...field}
                            type="text"
                            className="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Locality</label>
                      <Controller
                        control={control}
                        name="branchDetailsLocality"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">City</label>
                      <Controller
                        control={control}
                        name="branchDetailsCity"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Pin code</label>
                      <Controller
                        control={control}
                        name="branchDetailsPincode"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Phone Number</label>
                      <Controller
                        control={control}
                        name="branchDetailsPhoneNo"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="tel"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Alter Number</label>
                      <Controller
                        control={control}
                        name="branchDetailsAltPhoneNo"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="tels"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">GST In</label>
                      <Controller
                        control={control}
                        name="gstIn"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>

                <div className="bankDetails_container">
                  <header className="header_title">Bank Details</header>
                  {!bankDetails || bankDetails === "" ? (
                    <h6 style={{ color: "red" }}>
                      Please Select Branch (or) Bank Details Not Available
                    </h6>
                  ) : null}
                  <div className="commonForm_container">
                    <div className="input_container">
                      <label className="inputLabel">Account Holder Name</label>
                      <Controller
                        control={control}
                        name="currentAccHolderName"
                        rules={{
                          required: "Bank details are required. Please select bank details.",
                        }}
                        render={({
                          field: { onChange, onBlur, value, ref },
                          fieldState: { error },
                        }) => (
                          <>
                            <input
                              type="text"
                              list="bankList"
                              onBlur={onBlur}
                              ref={ref}
                              value={value || ""}
                              onChange={(e) => {
                                const selectedText = e.target.value;
                                setSelectedBankValue(selectedText);

                                const match = bankDetails && bankDetails?.find(
                                  (data) =>
                                    `${data?.currentAccHolderName} : ${data?.accNo}` ===
                                    selectedText
                                );

                                if (match) {
                                  onChange(match?.currentAccHolderName); // store only the name
                                } else {
                                  onChange(""); // clear if unmatched
                                }
                              }}
                              className="commonInputCss"
                              placeholder="Select bank details"
                            />

                            <datalist id="bankList">
                              {bankDetails && bankDetails?.map((data, index) => (
                                <option
                                  key={index}
                                  value={`${data.currentAccHolderName} : ${data.accNo}`}
                                />
                              ))}
                            </datalist>

                            {error && (
                              <span style={{ color: "red", fontSize: "12px" }}>
                                {error?.message}
                              </span>
                            )}
                          </>
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Bank Name</label>
                      <Controller
                        control={control}
                        name="bankName"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">A/C No</label>
                      <Controller
                        control={control}
                        name="accNo"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">IFSC Code</label>
                      <Controller
                        control={control}
                        name="ifscCode"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Branch & Type</label>
                      <Controller
                        control={control}
                        name="branch"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Gpay / Upi Number</label>
                      <Controller
                        control={control}
                        name="phoneNo"
                        render={({ field }) => (
                          <input
                            {...field}
                            type="text"
                            className="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div
                      className="input_container"
                      style={{ display: "none" }}
                    >
                      <label className="inputLabel">Status</label>
                      <Controller
                        control={control}
                        name="interest"
                        defaultValue="Interested"
                        render={({ field }) => (
                          <select {...field} className="commonInputCss">
                            <option value="Interested">Interested</option>
                            <option value="Not Interested">
                              Not Interested
                            </option>
                          </select>
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="submitBtnContainer">
                <button className="submitBtn" type="submit">
                  {postLoading || putLoading ? (
                    <>
                      <i class="fa fa-circle-o-notch fa-spin"></i>
                    </>
                  ) : (
                    <> Get Proforma</>
                  )}
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
      <Popup
        isOpen={isModalOpen}
        closePopup={closeModal}
        popupType={popupType}
        setPopupType={setPopupType}
        message="Proforma Added Successfully!"
        updatemessage="Proforma Updated Successfully!"
        state={state?.id}
        navigateUrl="/invoice/proformaInvoiceBill"
        proformaData={proformaData}
      />
    </>
  );
}
